(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledPagination', {
            templateUrl: 'app/components/styled-pagination/styled-pagination.html',
            controller: styledPaginationController,
            bindings: {
                startRegistry: '=',
                endRegistry: '=',
                totalItems: '=',
                currentPage: '=',
                numPerPage: '=',
                maxSize: '=',
                onChange: "&",
            }
        })
        .directive("changePage", function () {
            return {
                restrict: "A",
                link: function (scope, elem, attrs) {
                    scope.$watch(attrs["ngModel"], function (newVal, oldVal) {
                        if (oldVal === undefined || newVal === oldVal) {
                            return;
                        }
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ value: newVal });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function styledPaginationController($window, $scope) {
        var $ctrl = this;

        function updateIsMobile() {
            $ctrl.isMobile = $window.innerWidth <= 768;
        }

        updateIsMobile();

        angular.element($window).on('resize', function () {
            $scope.$apply(updateIsMobile);
        });

        $ctrl.getMaxSize = function () {
            return $ctrl.isMobile ? 4 : $ctrl.maxSize;
        };
    }
})();
